<template>
  <VaCard>
    <VaCardContent class="flex-nowrap">
      <section class="flex flex-col gap-y-5 overflow-x-auto">
        <header class="flex items-center justify-between">
          <div class="flex flex-col gap-2 sm:items-start">
            <h3 class="mb-3 font-bold text-lg">Viajes activos</h3>
          </div>
          <div class="flex flex-col gap-2 sm:items-end">
            <div
              class="p-1 rounded"
              :style="{
                backgroundColor: iconBackground,
                color: iconColor,
              }"
            >
              <slot name="icon"></slot>
            </div>
          </div>
        </header>
        <div class="body-content justify-between">
          <div class="scrollable-data-list">
            <div class="table-scroll-wrapper overflow-x-auto max-w-full">
              <VaDataTable
                class="region-revenue-table"
                :columns="[
                  { label: 'ID', key: 'id', sortable: true },
                  { label: 'Muelle', key: 'muelle', sortable: true },
                  { label: 'N° redondilla / Cupo', key: 'id_lancha', sortable: true },
                  { label: 'Embarcación', key: 'embarcacion_id', sortable: true },
                  { label: 'Patrón', key: 'patron', sortable: false },
                  { label: 'Tripulantes', key: 'tripulantes', sortable: false },
                  { label: 'Fecha', key: 'fecha_viaje', sortable: true },
                ]"
                :items="showList"
              >
                <template #cell(id)="{ rowData }">
                  <div class="ellipsis">
                    {{ rowData.id }}
                  </div>
                </template>
                <template #cell(muelle)="{ rowData }">
                  <div class="ellipsis">
                    {{ rowData.muelle }}
                  </div>
                </template>
                <template #cell(fecha_viaje)="{ rowData }">
                  <div class="ellipsis">
                    {{ showableDate(new Date(rowData.fecha_viaje)) }}
                  </div>
                </template>
                <template #cell(id_lancha)="{ rowData }">
                  <div class="ellipsis">
                    {{ rowData.embarcacionData?.id_lancha }}
                  </div>
                </template>
                <template #cell(embarcacion_id)="{ rowData }">
                  <div class="ellipsis">
                    {{ rowData.embarcacionData?.nombre_embarcacion }}
                  </div>
                </template>
                <template #cell(patron)="{ rowData }">
                  <div class="ellipsis">{{ rowData.patronData?.nombre_completo }}</div>
                </template>
                <template #cell(tripulantes)="{ rowData }">
                  <div class="ellipsis">
                    {{
                      rowData.tripulantesData.length +
                      (rowData.asociationData.some((a) => a.tipo_objeto_2 == RequestObjectType.Armador) ? 1 : 0) +
                      1
                    }}
                  </div>
                </template>
                <template #cell(permisoMuelleWeste)="{ rowData }">
                  <div class="flex justify-center">
                    <VaChip
                      v-if="rowData.permisoMuelleWesteData?.estado == RequestStatus.PENDING"
                      color="default"
                      size="small"
                      icon="pending"
                    >
                      Pendiente
                    </VaChip>
                    <VaChip
                      v-else-if="rowData.permisoMuelleWesteData?.estado == RequestStatus.APPROVED"
                      color="success"
                      size="small"
                      icon="check"
                    >
                      Aprobado
                    </VaChip>
                    <VaChip
                      v-else-if="rowData.permisoMuelleWesteData?.estado == RequestStatus.REJECTED"
                      color="danger"
                      size="small"
                      icon="close"
                    >
                      Rechazado
                    </VaChip>
                    <div v-else>--</div>
                  </div>
                </template>
                <template #cell(estado)="{ rowData }">
                  <div class="flex justify-center">
                    <VaChip
                      v-if="
                        rowData.posicionamientosData.length == 0 &&
                        rowData.activo &&
                        rowData.marca_salida == null &&
                        rowData.estado == null &&
                        rowData.asociationData.some((req) => req.estado === RequestStatus.APPROVED) &&
                        new Date(rowData.fecha_viaje).getTime() >= new Date().getTime() - 1000 * 60 * 60 * 10 &&
                        new Date(rowData.fecha_viaje).getTime() <= new Date().getTime() + 1000 * 60 * 60 * 10
                      "
                      color="info"
                      size="small"
                      icon="access_time"
                    >
                      Preparado
                    </VaChip>
                    <VaChip
                      v-else-if="
                        rowData.activo &&
                        rowData.marca_salida == null &&
                        rowData.estado == null &&
                        rowData.asociationData.some((req) => req.estado === RequestStatus.APPROVED) &&
                        new Date(rowData.fecha_viaje).getTime() >= new Date().getTime() - 1000 * 60 * 60 * 10 &&
                        new Date(rowData.fecha_viaje).getTime() <= new Date().getTime() + 1000 * 60 * 60 * 10
                      "
                      color="success"
                      size="small"
                      icon="check"
                    >
                      Aprobado
                    </VaChip>
                    <VaChip
                      v-else-if="
                        rowData.estado == null &&
                        rowData.asociationData.length > 0 &&
                        rowData.asociationData.every((req) => req.estado === RequestStatus.REJECTED)
                      "
                      color="danger"
                      size="small"
                      icon="close"
                    >
                      Rechazado
                    </VaChip>
                    <VaChip
                      v-else-if="rowData.estado === ViajeEstado.CANCELADO"
                      class="status-chip"
                      size="small"
                      color="danger"
                      icon="error"
                      >Cancelado</VaChip
                    >
                    <VaChip
                      v-else-if="
                        rowData.activo &&
                        rowData.marca_salida == null &&
                        rowData.estado == null &&
                        rowData.asociationData.every((req) => req.estado !== RequestStatus.APPROVED) &&
                        rowData.asociationData.some((req) => req.estado === RequestStatus.PENDING)
                      "
                      class="status-chip"
                      size="small"
                      color="warning"
                      icon="error"
                      >Pendiente</VaChip
                    >
                  </div>
                </template>
              </VaDataTable>
            </div>
          </div>
        </div>
      </section>
    </VaCardContent>
  </VaCard>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, Ref, watch } from 'vue'
import VaTimelineItem from '../../../../components/va-timeline-item.vue'
import dataStorageManager, { BucketDefaultIDs } from '../../../../managers/data/DataStorageManager'
import { IRequest, RequestObjectType, RequestStatus } from '../../../../services/api-services/RequestsServices'
import { OperatedViaje, ViajeEstado } from '../../../../services/api-services/ViajesServices'
import identityManager, { LoggedInUser } from '../../../../managers/identity/IdentityManager'
import { IArmador } from '../../../../services/api-services/ArmadoresServices'
import { useColors } from 'vuestic-ui'
import dataHubServices from '../../../../services/data-hub-services/DataHubServices'
import { viajesHubName, ViajesHubPipelines } from '../../../../services/data-hub-services/ViajesHub'

const { getColor } = useColors()

const iconBackground = getColor('success')
const iconColor = getColor('on-success')

const fullViajesList: Ref<OperatedViaje[]> = ref([])

const activeArmadorIdRef = identityManager.getRefActiveArmadorId()
const armadoresList: Ref<IArmador[]> = dataStorageManager.subscribeBucket<IArmador>(
  BucketDefaultIDs.ARMADORES,
  () => {},
)
const armadorId = computed<number | null>(() => {
  if (activeArmadorIdRef.value !== null) return activeArmadorIdRef.value
  const user = identityManager.getUser()
  if (!user) return null
  const armador = armadoresList.value.find((a) => a.rut_representante.toString() === user.rut.toString())
  return armador?.id ?? null
})

const fullList: Ref<OperatedViaje[]> = ref([])
const showList: Ref<OperatedViaje[]> = ref([])

onMounted(() => {
  dataHubServices.subscribeToHub(viajesHubName, {
    subscriberID: 'armadorViajesActivos_viajes',
    pipeline: ViajesHubPipelines.VIAJES_WITH_TRIPULANTES,
    callback: (data: OperatedViaje[]) => {
      fullViajesList.value = data
    },
  })
})

watch([fullViajesList, armadorId], () => {
  fullList.value = fullViajesList.value.filter(
    (viaje) => viaje.estado == null && viaje.id_armador?.toString() === armadorId.value?.toString(),
  )
})

watch(fullList, () => {
  const less12 = new Date(new Date().getTime() - 10 * 1000 * 60 * 60)
  const plus12 = new Date(new Date().getTime() + 24 * 1000 * 60 * 60)
  showList.value = fullList.value
    .sort((a, b) => {
      const dateA = new Date(a.fecha_viaje)
      const dateB = new Date(b.fecha_viaje)
      return dateB.getTime() - dateA.getTime()
    })
    // Cortar a los 15 últimos eventos. Si los eventos estan entre hoy -10h y hoy +24h, mostrarlos
    .filter((v, index) => {
      const eventDate = new Date(v.fecha_viaje)
      return (eventDate.getTime() > less12.getTime() && eventDate.getTime() < plus12.getTime()) || index < 15
    })
})

// ISO string to dd/mm/aaaa hh:mm
function showableDate(date: Date) {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`
}
</script>
<style scoped>
.limited-height-card {
  max-height: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.scrollable-table {
  overflow-y: auto;
  height: 100%;
  max-height: 520px;
}

.content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

b {
  color: #4774bd; /* Tailwind's blue-500 color */
}
</style>
